import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import IdleTimer from "react-idle-timer";
import { menuTypeAction } from "./store/actions";
import { connect } from "react-redux";
import { IkioskMenuIds } from "./models/kioskModel2";
import moment from "moment";
import { getSessionTime } from "./helpers/helpersIndex";

class AppIdle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeout: 60000 * getSessionTime(),
    };
    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    // this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
  }
  _onAction(e) {
    console.log("useridle did something",e,this.idleTimer,this.props.kioskMenutype);
    if (this.props.kioskMenutype === IkioskMenuIds.PROMOTIONALSLIDE){
      this.props.menuTypeAction(IkioskMenuIds.LOGINPAGE);
    }
    // this.setState({ isTimedOut: false })
  }

  _onActive(e) {
    console.log("useridle is active", e);
    // this.setState({ isTimedOut: false })
  }

  _onIdle(e) {
    console.log("useridle is idle", e, this.props.history.location.pathname);
    let currentTimeHour = moment(new Date(this?.props?.dateTime)).format("hh") || new Date().getHours();
    let starttime = this?.props?.kioskStartTime || undefined;
    let endTime = this?.props?.kioskEndTime || undefined;
    const isStartTimeExceeded = currentTimeHour >= starttime;
    const isEndTimeExceeded = currentTimeHour >= endTime;
    const startTimeExceed = currentTimeHour < starttime;
    if (!((isStartTimeExceeded && isEndTimeExceeded) || (startTimeExceed)) && (this?.props?.promotionalData?.length > 0) && (this.props.kioskMenutype === IkioskMenuIds.LOGINPAGE))
      {
        this.props.menuTypeAction(IkioskMenuIds.PROMOTIONALSLIDE);
      }
    this.idleTimer.reset();
  }
  render() {
    return (
      <>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          element={document}
          //   onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={500}
          timeout={this.state.timeout}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  kioskMenutype: state?.kioskReducer2?.selectedPage,
  dateTime: state?.kioskReducer2?.currentDateAndTime,
  kioskStartTime: state?.kioskReducer2?.kioskStartTime,
  kioskEndTime: state?.kioskReducer2?.kioskEndTime,
  promotionalData:state?.kioskReducer2?.promotionalData
});

export default withRouter(
  connect(mapStateToProps, { menuTypeAction })(AppIdle)
);
